/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-04-23
 * Copyright All Rights Reserved
 */
// @flow
import * as React from 'react';
import { Row } from 'reactstrap';
import { mainHeadingRow } from './MainHeadingRow.module.scss';

type Props = {
  children: React.Node,
}

const MainHeadingRow = ({ children }: Props) => (
  <Row className={mainHeadingRow}>
    {children}
  </Row>
);
export default MainHeadingRow;



// WEBPACK FOOTER //
// ./js/components/support/layout/MainHeadingRow/index.jsx